import { createContext, use } from 'react';

import type { ScreenSizeName } from '../config/screen-sizes';

export type ScreenSizeContextState = {
    size: ScreenSizeName;
} & {
    [K in `is${Capitalize<ScreenSizeName>}`]: boolean;
};

export const ScreenSizeContext = createContext<ScreenSizeContextState | null>(
    null,
);

export function useScreenSize() {
    const context = use(ScreenSizeContext);

    if (!context) {
        throw new Error(
            'useNavigationRoot must be used within a NavigationRootProvider',
        );
    }

    return context;
}
